/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Staples_RemovedInputs */

const en_staples_removed = /** @type {(inputs: Staples_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Removed ${i?.name} from staples`)
};

const de_staples_removed = /** @type {(inputs: Staples_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aus den Vorräten entfernt`)
};

/**
* | output |
* | --- |
* | "Removed {name} from staples" |
*
* @param {Staples_RemovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staples_removed = /** @type {((inputs: Staples_RemovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staples_RemovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staples_removed(inputs)
	return en_staples_removed(inputs)
});